// import { useState, useEffect } from "react";
// import getOpaqueIds from "/imports/plugins/core/core/client/util/getOpaqueIds";
// import useCurrentInternalShopId from "./useCurrentInternalShopId.js";

/**
 * React Hook that gets the globally current shop ID
 * @return {Array} [currentShopId]
 */
export default function useCurrentShopId() {
/*
  const [internalShopId] = useCurrentInternalShopId();
  const [currentShopId, setCurrentShopId] = useState(null);

  useEffect(() => {
    let isMounted = true;

    getOpaqueIds([
      { namespace: "Shop", id: internalShopId }
    ])
      .then(([opaqueShopId]) => {
        if (isMounted) setCurrentShopId(opaqueShopId);
        return null;
      })
      .catch((error) => {
        console.error(error);
      });

    return () => {
      isMounted = false;
    };
  }, [internalShopId]);

  return [currentShopId];
  */

  return ["cmVhY3Rpb24vc2hvcDpKOEJocTN1VHRkZ3daeDNyeg=="];
}
